import { Data } from '.generated/templates/Feature.Data.model';
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import React from 'react';
import { classnames } from 'tailwindcss-classnames';
import RichTextA11yWrapper from '../RichTextA11yWrapper';
import Button from 'components/helpers/Button';

export type TimelineItemProps = Sitecore.Override.ItemEx &
  Data.Timeline.Fields.TimelineItem & {
    index: number;
    total: number;
    alignment: string;
  };

export type TimelinePathProps = {
  isLast: boolean;
};

export const TimelinePath = ({ isLast }: TimelinePathProps): React.JSX.Element => {
  return (
    <div className={classnames('flex', 'flex-col', 'items-center')}>
      <span className={classnames('timeline-circle')} />
      {!isLast && <span className={classnames('timeline-line', 'bg-gray-midGray')} />}
    </div>
  );
};

const TimelineItem = ({
  fields,
  index,
  total,
  alignment,
}: TimelineItemProps): React.JSX.Element => {
  const linkPresent = !!fields.cta1?.value.href;
  const isLast = index === total - 1;

  let itemClasses = classnames();
  if (alignment === 'center') {
    const isLeft = index % 2 === 0;
    itemClasses = classnames('md:timeline-item-center', {
      'md:flex-row-reverse': isLeft,
      'md:text-right': isLeft,
      'md:text-left': !isLeft,
    });
  }

  return (
    <li className={classnames('flex', itemClasses)}>
      <TimelinePath isLast={isLast} />
      <div className={classnames('block', 'mx-4', 'my-2', 'flex-1')}>
        <RichTextA11yWrapper
          className={classnames('timeline-item-label')}
          field={fields?.label}
          editable
        />
        <RichTextA11yWrapper className={classnames('rte')} field={fields?.description} editable />
        {linkPresent && (
          <div className={classnames('my-2')}>
            <Button linkField={fields.cta1} variant="link" className={classnames('underline')} />
          </div>
        )}
      </div>
    </li>
  );
};

export default TimelineItem;
